<template>
  <div>
    <section style="display: inherit">
      <a
        @click="fnShowModal()"
        v-b-tooltip.hover
        title="Lead status change"
        v-if="buttonType == 'icon'"
        ><i class="las la-business-time text-primary fs-1100"></i
      ></a>

      <button
        v-if="buttonType == 'button'"
        class="btn btn-primary btn-sm"
        @click="fnShowModal()"
        v-b-tooltip.hover
        title="Lead status change"
      >
        Change status
      </button>

      <b-modal ref="modal" hide-footer title="Lead status - update">
        <div class="d-block">
          <dl class="row">
            <dt class="col-sm-4">Current status</dt>
            <dd class="col-sm-8">
              <WDLeadsStatusBadge :status="row.status"></WDLeadsStatusBadge>
            </dd>
            <dt class="col-sm-4">Change status</dt>
            <dd class="col-sm-8">
              <div class="form-group">
                <b-form-select
                  plain
                  autocomplete="off_status"
                  placeholder=" "
                  :options="optionStatus"
                  v-model="status"
                ></b-form-select>
                <label class="floatingLabel" for="status">Status</label>
                <div class="invalid-feedback" v-if="errors.status">
                  {{ errors.status[0] }}
                </div>
              </div>
            </dd>
          </dl>
          <hr />
          <div class="text-right">
            <button
              type="button"
              class="btn btn-secondary btn-sm mr-2"
              @click="hideModal"
            >
              Cancel
            </button>
            <button
              type="button"
              @click="fnUpdate()"
              class="btn btn-success btn-sm"
            >
              Update
            </button>
          </div>
        </div>
      </b-modal>
    </section>

    <!-- Send email about change status of the  leads or quote -->
    <appModalEmailSendingConfirmation
      ref="modalEmailSendingConfirmation"
      :recordId="row.id"
      :row="row"
    ></appModalEmailSendingConfirmation>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { optionLeadsStatus } from '../../services/data.service'
import * as messageService from '../../services/message.service'
import * as leadsService from '../../services/leads.service'
import datePicker from 'vue2-datepicker'
import WDLeadsStatusBadge from '../../components/wd/WDLeadsStatusBadge.vue'
import appModalEmailSendingConfirmation from '../../components/emailTemplate/ModalEmailSendingConfirmation.vue'
export default {
  name: 'ModalLeadStatusUpdate',
  props: {
    row: {
      type: Object,
      required: true
    },
    buttonType: {
      type: String,
      default: 'icon'
    }
  },
  components: {
    datePicker,
    WDLeadsStatusBadge,
    appModalEmailSendingConfirmation
  },
  data() {
    return {
      errors: {},
      id: '',
      status: '',
      optionStatus: optionLeadsStatus,
      singleQuote: {}
    }
  },
  computed: {
    ...mapGetters(['getAdminLeadsPaginate', 'getLeadsPaginate'])
  },
  methods: {
    ...mapActions(['fetchAdminLeadsPaginate', 'fetchLeadsPaginate']),
    fnShowModal() {
      this.showModal()
    },
    hideModal() {
      this.id = ''
      this.status = ''
      this.$refs.modal.hide()
    },
    showModal() {
      this.$refs.modal.show()
    },

    fnUpdate: async function () {
      const obj = {
        status: this.status
      }

      try {
        this.errors = {}

        const response = await leadsService.updateLeadsStatus(this.row.id, obj)
        const { status_code } = response.data

        if (status_code == 200) {
          this.$emit('fnRefresh')
          this.$refs['modalEmailSendingConfirmation'].showModal()

          // if (this.roleId === 1) {
          //   this.fetchAdminLeadsPaginate(this.getAdminLeadsPaginate)
          // }

          // if (this.roleId === 3) {
          //   this.fetchLeadsPaginate(this.getLeadsPaginate)
          // }

          messageService.fnSweetAlertSuccessToast(
            'Leads status',
            'Updated successfully '
          )

          this.hideModal()
        }
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Leads status',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Leads status - updated',
              'Something wrong'
            )
            break
        }
      }
    }
  }
}
</script>
